import spacetime, { Spacetime } from 'spacetime'

export const MS_IN_SECOND = 1000
export const MS_IN_MINUTE = 60 * MS_IN_SECOND
export const MS_IN_HOUR = MS_IN_MINUTE * 60
export const MS_IN_DAY = MS_IN_HOUR * 24
export const MS_IN_THREE_DAYS = MS_IN_DAY * 3

export const formatTimeDifference = (time: Spacetime): string | undefined => {
  const since = spacetime.now().since(time).diff
  if (since.months > 0) {
    return `${since.months} month${maybePlural(since.months)}`
  }
  if (since.days > 0) {
    return `${since.days} day${maybePlural(since.days)}`
  }
  if (since.hours > 0) {
    return `${since.hours} hour${maybePlural(since.hours)}`
  }
  if (since.minutes >= 0) {
    return since.minutes
      ? `${since.minutes} minute${maybePlural(since.minutes)}`
      : 'less than \n 1 minute'
  }

  return undefined
}

const maybePlural = (timeValue: number): string => (timeValue === 1 ? '' : 's')
